import React, { useState } from 'react'
import { Wrapper } from './style'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton } from 'src/components/Global/Button/Button'
import { TargetAmountModal } from './plans-redux-modal/PlanAmount'
import { DatePicker } from 'src/components/Global/Date/Date'
import { ToastContainer, toast } from 'react-toastify'
import { ModalTitleText } from 'src/components/Global/Text/TitleText'

import 'react-toastify/dist/ReactToastify.css'
const TargetTimeLine = () => {
  let today = new Date()
  const [planData, setPlanData] = useState({
    start_date: today,
    maturity_date: '',
  })

  const dispatch = useDispatch()
  const { start_date, maturity_date } = planData

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    dispatch(action(PlanTypes._UPDATE_PLAN_FORM, newData))
  }

  const [showModal, setShowModal] = useState(false)
  const createPlan = (e: any) => {
    e.preventDefault()
    if (!maturity_date || !start_date) {
      toast.warn('Date can not be empty!', {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      return
    }
    setShowModal(true)
  }

  const Disabled = () => {
    if (!maturity_date || !start_date) {
      return 'blur'
    }
    return null
  }

  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <div>
            <ModalTitleText>Start Date</ModalTitleText>
            <p className="desc">
              When do you want to start savings (tap to change date)?
            </p>
            <DatePicker
              type="date"
              value={start_date}
              onChange={handleChange}
              name="start_date"
              placeholder="Start Date"
            />
          </div>
          <div>
            <ModalTitleText>End Date</ModalTitleText>
            <p className="desc">
              Choose your preferred end date (tap to change date)?
            </p>
            <DatePicker
              type="date"
              value={maturity_date}
              onChange={handleChange}
              name="maturity_date"
              placeholder="maturity_date"
            />
          </div>
        </div>
        <TargetAmountModal showModal={showModal} setShowModal={setShowModal} />

        <div>
          <ModalButton onClick={createPlan} className={`button ${Disabled()}`}>
            Continue
          </ModalButton>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </form>
    </Wrapper>
  )
}

export { TargetTimeLine }
